import React from "react";

export default function DeviceDropdown({ devices, selected, onSelect }) {
  return (
    <div style={{ background: "#fff", padding: 20, borderRadius: 8, boxShadow: "0 5px 15px rgba(0,0,0,0.05)" }}>
      <h3>Select Device</h3>
      <select value={selected || ""} onChange={(e) => onSelect(e.target.value)} style={{ width: "100%", padding: 10 }}>
        <option value="">-- choose device --</option>
        {devices.map((d) => (
          <option key={d.deviceId} value={d.deviceId}>
            {d.deviceId} (count: {d.count}/{d.limit})
          </option>
        ))}
      </select>
    </div>
  );
}
